export * from './normalizeNumber';
export { normalizeNumber as default } from './normalizeNumber';
